import { css } from '@emotion/react';
import { themed } from '@spotnana/blocks/src/utils';

// zIndex.snackbar + 2 to be above the Bonvoy login modal
export const modal = themed(
  ({ zIndex }) => css`
    z-index: ${zIndex.snackbar + 2};
  `,
);
